export const toStringId = value => (value == null ? '' : value.toString());

/** Converts any value to its string representation; returns '' for null/undefined. */
export const toStr = value => (value == null ? '' : String(value));

/** Filters and normalizes an array to non-empty strings. */
export const sanitizeStrArr = arr =>
	Array.isArray(arr) ? arr.map(toStr).filter(Boolean) : [];

/** Filters an array to only plain objects (non-null). */
export const toSelectOpts = arr =>
	Array.isArray(arr) ? arr.filter(item => item != null && typeof item === 'object') : [];

/**
 * Parses a YYYY-MM-DD string into a local-timezone Date object.
 * Avoids UTC-shift bugs that arise from `new Date('YYYY-MM-DD')`.
 */
export const formatDate = dateString => {
	if (!dateString) return null;
	const [year, month, day] = dateString.split('-');
	return new Date(Number(year), Number(month) - 1, Number(day));
};

export const getDataFiscalizacionForModal = data => ({
	...data,
	_id: toStringId(data?._id),
	fecha: data?.inspection_date || '',
	tipo: toStringId(data?.inspection_types?._id || data?.inspection_type?._id || data?.inspection_type_id),
	establecimiento_id: toStringId(data?.establishment?._id || data?.establishment_id),
	entidades: (data?.inspection_authorities || []).map(item => toStringId(item?._id)),
	responsable_id: toStringId(
		data?.person?._id || data?.responsible_person?._id || data?.responsible_person_id
	),
	management_position_id: toStringId(
		data?.management_position?._id ||
			data?.person?.management_position?._id ||
			data?.person?.management_position_id ||
			data?.responsible_person?.management_position?._id ||
			''
	),
	fiscalizadores: (data?.fiscalizer_ids || []).map(toStringId),
	observaciones: data?.observation || '',
	documento_id: data?.file_id || null,
	file_id: data?.file_id || null,
	finding_closure_file_id: data?.finding_closure_file_id || null,
	incumplimientos: data?.incumplimientos || [],
});
